<template>
  <div>
    <h1>{{ storyTitle }}</h1>
      <dynamic-story :episode="episode" :chapter="chapter" :story="story" data="null" :key="[story, episode, chapter]"/>
    <transition name="fade" mode="out-in">
    </transition>
  </div>
</template>

<script>
import DynamicStory from '@/components/StoryTemplate.vue'
import config from '@/config.js'
export default {

  name: 'chapter',
  components: {
    DynamicStory
  },
  props: {
    episode: String,
    chapter: String,
    story: String
  },
  data () {
    return {
      episodes: config.episodes
    }
  },
  computed: {
    /* episode () {
      return JSON.stringify(this.$store.state.progress.episode)
    },
    chapter () {
      return JSON.stringify(this.$store.state.progress.chapter)
    }, */
    chapters () {
      return this.episodes[this.episode].chapters
    },
    currentChapter () {
      return this.chapters[this.chapter]
    },
    storyTitle () {
      return this.currentChapter.titles[this.story]
    }
  },
  mounted () {
    document.title = this.storyTitle + ' - TPFLA'
  }
}
</script>

<style lang="css" scoped>
</style>
